/** Tipografías disponibles para apariencia de la tienda. */

export type StoreFontOption = {
  /** Valor persistido en theme.fontFamily (CSS font-family). */
  value: string;
  label: string;
  /** Familia para preview / Google Fonts (sin comillas extras). */
  family: string;
  /** Si true, hay que cargar la hoja de Google Fonts. */
  google?: boolean;
};

export const STORE_FONT_OPTIONS: StoreFontOption[] = [
  {
    value: '',
    label: 'Sistema (default)',
    family: 'system-ui',
  },
  {
    value: 'Roboto, "Helvetica Neue", Arial, sans-serif',
    label: 'Roboto',
    family: 'Roboto',
    google: true,
  },
  {
    value: '"Open Sans", Arial, sans-serif',
    label: 'Open Sans',
    family: 'Open Sans',
    google: true,
  },
  {
    value: 'Lato, Arial, sans-serif',
    label: 'Lato',
    family: 'Lato',
    google: true,
  },
  {
    value: 'Montserrat, Arial, sans-serif',
    label: 'Montserrat',
    family: 'Montserrat',
    google: true,
  },
  {
    value: 'Poppins, Arial, sans-serif',
    label: 'Poppins',
    family: 'Poppins',
    google: true,
  },
  {
    value: 'Inter, Arial, sans-serif',
    label: 'Inter',
    family: 'Inter',
    google: true,
  },
  {
    value: 'Nunito, Arial, sans-serif',
    label: 'Nunito',
    family: 'Nunito',
    google: true,
  },
  {
    value: '"Source Sans 3", Arial, sans-serif',
    label: 'Source Sans 3',
    family: 'Source Sans 3',
    google: true,
  },
  {
    value: '"Playfair Display", Georgia, serif',
    label: 'Playfair Display',
    family: 'Playfair Display',
    google: true,
  },
];

export const findStoreFontOption = (fontFamily?: string | null): StoreFontOption => {
  const value = fontFamily ?? '';
  return STORE_FONT_OPTIONS.find((opt) => opt.value === value) ?? STORE_FONT_OPTIONS[0];
};

/** URL de la hoja CSS de Google Fonts para las familias indicadas. */
export const buildGoogleFontsStylesheetUrl = (families: string[]): string | null => {
  const unique = Array.from(new Set(families.map((f) => f.trim()).filter(Boolean)));
  if (!unique.length) return null;
  const familyParams = unique
    .map((family) => `family=${encodeURIComponent(family).replace(/%20/g, '+')}:wght@400;500;600;700`)
    .join('&');
  return `https://fonts.googleapis.com/css2?${familyParams}&display=swap`;
};

export const getGoogleFontFamiliesToLoad = (fontFamily?: string | null): string[] => {
  const option = findStoreFontOption(fontFamily);
  return option.google ? [option.family] : [];
};
